import styled, { css, keyframes } from "styled-components";
import { ReactComponent as Arrow } from "../../assets/icons/arrow.svg";

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: var(--shadow-panel);
  max-height: 95dvh;
  max-width: 400px;
  position: relative;
  z-index: 1000;

  overflow-y: unset;

  border-radius: 30px;
  border: 1px solid var(--color-line);
  background:
    radial-gradient(
      circle at top right,
      rgba(var(--color-brand-400-rgb), 0.14),
      transparent 0 34%
    ),
    linear-gradient(
      180deg,
      rgba(28, 43, 68, 0.96) 0%,
      rgba(18, 24, 36, 0.98) 100%
    );
  @media (max-height: 835px) {
    overflow-y: ${(p) => (!p.$isBodywriting ? "unset" : "auto")};
  }
`;
export const Textarea = styled.textarea`
  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 20px;
  border: 1px solid var(--color-line);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.68) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );

  font-family: var(--font-family-primary);
  color: var(--color-text-strong);
  font-size: 15px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.01em;

  resize: vertical;
  min-height: 126px;
  outline: none;

  &::placeholder {
    color: var(--color-text-dim);
  }
`;

export const ModalTitle = styled.h2`
  font-family: var(--font-family-primary);
  color: var(--color-text-strong);
  font-size: 21px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.03em;
  text-align: left;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;
export const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const FavoriteButton = styled.div`
  width: 34px;
  height: 34px;
  position: relative;
  z-index: 2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-pill);
  border: 0.5px solid rgba(var(--color-brand-300-rgb), 0.14);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.68) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );
  box-shadow:
    0 10px 24px rgba(0, 0, 0, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
`;
export const Tags = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
`;

export const AdminActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
`;

export const AdminActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 0 14px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--color-line);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.66) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );
  color: var(--color-text-body);
  font-family: var(--font-family-primary);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition:
    opacity 180ms var(--ease-snappy),
    transform 180ms var(--ease-snappy),
    border-color 180ms var(--ease-snappy);

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    border-color: var(--color-line-strong);
  }
`;

export const Tag = styled.div`
  color: var(--color-text-strong);
  font-family: var(--font-family-primary);
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.01em;

  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: var(--radius-pill);
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.14);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.62) 0%,
    rgba(18, 24, 36, 0.86) 100%
  );
  box-shadow: inset 0 1px 0.4px rgba(255, 255, 255, 0.05);
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-pill);
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.14);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.68) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );
  color: var(--color-text-muted);
  transition:
    transform 180ms var(--ease-snappy),
    border-color 180ms var(--ease-snappy);

  &:hover {
    transform: translateY(-1px);
    border-color: var(--color-line-strong);
  }
`;

export const ModalContent = styled.div`
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  text-align: center;
`;

export const CropButton = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  padding: 6px;
  outline: none;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.16);
  right: ${(props) =>
    props.$shift ? `calc(10px + ${props.$shift}px)` : "10px"};
  border-radius: var(--radius-pill);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.82) 0%,
    rgba(18, 24, 36, 0.9) 100%
  );
  cursor: pointer;
  justify-content: center;
  z-index: 100;
  box-shadow: var(--shadow-micro);

  svg {
    path {
      stroke: var(--color-text-strong);
    }
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 240px;
  width: 170px;
  max-width: 170px;
  max-height: 240px;

  background:
    radial-gradient(
      circle at top right,
      rgba(var(--color-brand-400-rgb), 0.12),
      transparent 0 36%
    ),
    linear-gradient(
      180deg,
      rgba(31, 42, 64, 0.7) 0%,
      rgba(18, 24, 36, 0.9) 100%
    );
  border-radius: 24px;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.16);
  box-shadow:
    0 16px 34px rgba(0, 0, 0, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
`;
export const ImageRelative = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;
  align-items: center;
  position: relative;
`;
export const ArrowSvg = styled(Arrow)`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
  width: 33px;
  height: 33px;
  transform: translate(-50%, -50%);
`;
export const UploadButton = styled.button`
  border-radius: var(--radius-pill);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.9) 0%,
    rgba(18, 24, 36, 0.92) 100%
  );
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  display: flex;
  width: 90%;
  max-width: 248px;
  height: 33px;
  padding: 9px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  position: absolute;
  cursor: pointer;

  outline: none;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.16);
  left: 50%;
  bottom: 12px;

  transform: translateX(-50%);

  color: var(--color-text-strong);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  box-shadow:
    0 12px 24px rgba(0, 0, 0, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
`;

export const StyledCheckboxText = styled.div`
  color: var(--color-text-body);
  text-align: center;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
`;

const shake = keyframes`
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-6px); }
  40% { transform: translateX(6px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
`;

export const TermsCheckbox = styled.div`
  display: flex;
  padding: 6px 8px;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  cursor: pointer;
  border-radius: 18px;
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.7) 0%,
    rgba(18, 24, 36, 0.92) 100%
  );
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.14);
  ${({ $showOutline }) =>
    $showOutline &&
    css`
      outline: 1px solid var(--color-brand-700);
      outline-offset: 1px;
    `}

  ${({ $shake }) =>
    $shake &&
    css`
      animation: ${shake} 0.4s ease-in-out;
    `}
`;

export const Image = styled.img`
  max-width: 100%;
  border-radius: 12px;
  pointer-events: none;
  max-height: 100%;
  /* height: 100%; */
  width: 100%;

  object-fit: contain;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${(props) =>
    props.$hideImageContainer
      ? "transparent"
      : "rgba(var(--color-brand-400-rgb), 0.08)"};
  max-width: 100%;

  border-radius: 24px;
  max-width: 100%;
  max-height: 100%;
`;

export const ModalMessage = styled.p`
  color: var(--color-text-muted);
  text-align: left;
  font-family: var(--font-family-primary);
  font-size: 15px;
  font-weight: 400;
  line-height: normal;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  min-width: 0;
`;

export const CancelButton = styled.button`
  display: flex;
  width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--radius-pill);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.66) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );
  border: 1px solid var(--color-line);
  outline: none;

  color: var(--color-text-strong);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: rgba(var(--color-brand-300-rgb), 0.1);
    border-color: var(--color-line-strong);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  height: 44px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 4px;
  flex: 1 0 0;
  border-radius: var(--radius-pill);
  background: linear-gradient(
    180deg,
    var(--color-brand-500) 0%,
    var(--color-brand-600) 100%
  );
  cursor: pointer;
  border: 1px solid rgba(var(--color-brand-400-rgb), 0.18);
  outline: none;

  font-family: var(--font-family-primary);
  color: #07111f;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.01em;

  white-space: nowrap;
  transition:
    transform 180ms var(--ease-snappy),
    filter 180ms var(--ease-snappy);

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.03);
  }
`;

export const NudifyContainer = styled.div`
  border-radius: 18px;
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.7) 0%,
    rgba(18, 24, 36, 0.92) 100%
  );
  display: flex;
  padding: 8px 10px;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  align-self: stretch;
  flex-direction: row;
  min-height: 38px;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.14);
`;

export const NudifyText = styled.span`
  font-family: var(--font-family-primary);
  color: var(--color-text-body);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const FadeWrapper = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 48px;
    background: linear-gradient(to right, transparent, rgba(18, 24, 36, 0.98));
    pointer-events: none;
    transition: opacity 0.2s ease;
    opacity: ${({ $faded }) => ($faded ? 1 : 0)};
  }
`;

export const LabelText = styled.span`
  color: var(--color-text-body);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-align: left;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const Input = styled.input`
  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 18px;
  border: 1px solid var(--color-line);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.68) 0%,
    rgba(18, 24, 36, 0.88) 100%
  );

  font-family: var(--font-family-primary);
  color: var(--color-text-strong);
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.01em;

  &::placeholder {
    color: var(--color-text-dim);
  }
`;

export const CheckboxContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
`;
export const CheckboxContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, auto);
  gap: 6px;

  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  /* optional – lepši scroll */
  padding-bottom: 7px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background: rgba(var(--color-brand-300-rgb), 0.12);
  }

  &::-webkit-scrollbar-thumb {
    cursor: grab;
    background: var(--color-brand-600);
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--color-brand-500);
  }
  &::-webkit-scrollbar-thumb:active {
    background: var(--color-brand-600);
    cursor: grabbing;
  }
`;

export const Checkbox = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  cursor: pointer;
  height: 33px;
  border-radius: 16px;
  background: ${(p) =>
    p.$checked
      ? "rgba(var(--color-brand-400-rgb), 0.08)"
      : "linear-gradient(180deg, rgba(31, 42, 64, 0.7) 0%, rgba(18, 24, 36, 0.92) 100%)"};
  border: ${(p) =>
    p.$checked
      ? "1px solid rgba(var(--color-brand-400-rgb), 0.28)"
      : "1px solid transparent"};
`;

export const CheckboxText = styled.span`
  color: var(--color-text-body);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.16);
  position: absolute;
  top: 10px;
  padding-bottom: 2px;
  left: ${(props) =>
    props.$shift ? `calc(10px + ${props.$shift}px)` : "10px"};
  border-radius: var(--radius-pill);
  background: linear-gradient(
    180deg,
    rgba(31, 42, 64, 0.82) 0%,
    rgba(18, 24, 36, 0.9) 100%
  );
  cursor: pointer;
  justify-content: center;
  z-index: 100;
  width: 32px;
  height: 32px;
  box-shadow: var(--shadow-micro);

  svg {
    path {
      stroke: var(--color-text-strong);
    }
  }
`;
